export default __webpack_public_path__ + "static/media/sensotrend_signin_login_complete.12cac3c7.png";